export default {
  props: {
    // Tile type
    type: {
      type: Object,
      required: true
    },
    // Is tile data being displayed on the timeline
    selected: {
      type: Boolean,
      default: false
    },
    // Tooltip to display over this tile
    tooltip: {
      type: String,
      default: null
    },
    // Count of all entries for this tile
    entries: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
